// extracted by mini-css-extract-plugin
export var growableInput = "_5t-0";
export var tagContainer = "_5t-2";
export var textInput = "_5t-1";